import React from 'react';
import styled from 'styled-components';
import Skeleton from 'react-skeleton-loader';
import { Columns, Column } from '../base';

const StyledLoader = styled.div`
	padding: 1rem;
	background-color: #fff;
	box-shadow: 0 7px 17px 0 rgba(147,94,196,0.1);

	.image .react-skeleton-load {
		padding-top: 100%;
	}
`;

const StyledSpacer = styled.div`
	padding-bottom: 1rem;
`;

const ArticleBoxLoader = () => {
	return (
		<StyledLoader>
			<Columns>
				<Column tablet={1} desktopSmall={6 / 10}>
					<StyledSpacer />
					<StyledSpacer />
					<StyledSpacer />
					<Skeleton width="100%" height="40px" />
					<StyledSpacer />
					<StyledSpacer />
					<Skeleton width="100%" height="23px" />
					<StyledSpacer />
					<Skeleton width="100%" height="23px" />
					<StyledSpacer />
					<Skeleton width="100%" height="23px" />
					<StyledSpacer />
					<Skeleton width="100%" height="23px" />
				</Column>
				<Column tablet={1} desktopSmall={4 / 10}>
					<div className="image">
						<Skeleton width="100%" height="100%" widthRandomness="0" />
					</div>
				</Column>
			</Columns>
		</StyledLoader>
	);
};

export default ArticleBoxLoader;
